import React from 'react'
import { AphroditeIframe } from '@ui'
import { accessToken } from '@stores/apollo'
import Appbar from '../Appbar'
import { useHRLocations } from '@ui/selects/HRLocationSelect'
import { useUser } from '@hooks'
import { get } from 'lodash'
import LocationFilterNote from 'components/EmployeeManagement/LocationFilterNote'
import { legacyMode } from 'App'
interface IStackProps {
  cityName?: string
  buildingId?: string
  floorId?: string
}
export default function Stack({ cityName, buildingId, floorId }: IStackProps) {
  let url = '/ap/Current/stack'
  if (cityName) url = `${url}/${cityName}`
  if (buildingId) url = `${url}/${buildingId}`
  if (floorId) url = `${url}/${floorId}`
  const locations = useHRLocations()
  const user = useUser()
  const preferredLocation = get(user, 'user.employee.preferredLocations', [])
  const locationFilterNote =
    !legacyMode &&
    (preferredLocation.length === 0 || locations.length === preferredLocation.length ? null : (
      <LocationFilterNote />
    ))
  return (
    <>
      <Appbar title="Stack" locationFilterNote={locationFilterNote} />
      <AphroditeIframe token={accessToken} path={url} />
    </>
  )
}
